import React from "react";
import "./TicketingSystemInstanceTestConnection.scss";
import TicketingSystemInstanceConnectivity from "./TicketingSystemInstanceConnectivity/TicketingSystemInstanceConnectivity";
import TicketingSystemInstanceValidation from "./TicketingSystemInstanceValidation/TicketingSystemInstanceValidation";

interface TicketingSystemInstanceTestConnectionProps {
  id?: string;
  idInt?: number;
  runTestsOnLoad?: boolean;
  type?: string;
}

const TicketingSystemInstanceTestConnection: React.FC<
  TicketingSystemInstanceTestConnectionProps
> = ({ id, idInt, runTestsOnLoad, type }) => {
  return (
    <div className={"test-connection-wrapper"}>
      <TicketingSystemInstanceConnectivity
        id={idInt}
        runTestsOnLoad={runTestsOnLoad}
      />
      <TicketingSystemInstanceValidation id={id} idInt={idInt} type={type} />
    </div>
  );
};

export default TicketingSystemInstanceTestConnection;
